module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "statement"
  }, [(_vm.statement.length) ? _c('div', {
    staticClass: "statement__main",
    domProps: {
      "innerHTML": _vm._s(_vm.statement)
    }
  }) : _vm._e(), _c('h3', {
    staticClass: "statement__warning"
  }, [_vm._v(_vm._s(_vm.warningText))]), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f590847","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/views/certificate/components/statement/Statement.vue
// module id = 87abd56f8c33b809a4a4
// module chunks = 9